// extracted by mini-css-extract-plugin
module.exports = {"tab":"F-tabs-tab-1AJgV","tabs":"F-tabs-tabs-1yYGn","tabpanel":"F-tabs-tabpanel-2TR9L","tabSetBar":"F-tabs-tab-set-bar-RCAY2"};